import { IconFile } from "@tabler/icons-react"
import { type FC } from "react"

import { toSizeFormat } from "@forento/core/utilities/number"

import { CheckmarkIcon } from "~/components/Icon"
import LoadingBar from "~/components/LoadingBar"

const Uploading: FC<{ file: { name: string; size: number } }> = ({ file }) => (
	<div className="border-primary flex gap-4 rounded-lg border bg-white p-4">
		<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-4 border-[#f6f3ff] bg-[#edebf3]">
			<IconFile className="text-primary h-4 w-4" />
		</div>
		<div className="min-w-0 flex-1">
			<p className="mb-1 text-sm font-semibold break-words text-[#344054]">{file.name}</p>
			<p className="mb-2 text-sm text-[#667085]">{toSizeFormat(file.size)}</p>
			<LoadingBar />
		</div>
		<div className="bg-primary self-start rounded-full p-1">
			<CheckmarkIcon className="h-2 w-2 text-white" />
		</div>
	</div>
)

export default Uploading
